/**
 * Use Case: Create Voucher
 * Business logic for creating a new voucher.
 */

import type {
  CreateVoucherPayload,
  CreateVoucherResult,
} from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Create a new voucher
 */
export const CreateVoucherUseCase = async (
  payload: CreateVoucherPayload
): Promise<CreateVoucherResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.createVoucher(payload);
};

